module.exports = __webpack_public_path__ + "img/eye-grey-outline.6eaf16eb.svg";